import { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Label,
    Input,
    UncontrolledTooltip,
    Spinner
} from 'reactstrap';

const AutoTranslateConfirmationModal = ({ t, isOpen, toggle, loading, onConfirm }) => {
    const [syncTranslations, setSyncTranslations] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setSyncTranslations(false);
        }
    }, [ isOpen ])

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('Apply Changes to Other Languages')}
            </ModalHeader>
            <ModalBody>
                <Label check>
                    <Input
                        className="me-1"
                        type="checkbox"
                        checked={syncTranslations}
                        onChange={() => setSyncTranslations(!syncTranslations)}
                    />
                    <span>
                        {t('Apply and translate these changes to other languages')}
                    </span>
                    <i id="translate-all-helper-icon" className="ri-information-line me-1"></i>
                    <UncontrolledTooltip
                        target='translate-all-helper-icon'
                    >
                        {t('This will automatically translate your updates into all supported languages.')}
                    </UncontrolledTooltip>
                </Label>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
                <Button disabled={loading} color="primary" onClick={() => {
                    onConfirm(syncTranslations);
                }}>
                    {loading && <Spinner color='white' size="sm" />}
                    {' '}
                    {loading ? t('Saving...') : t('Save')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    AutoTranslateConfirmationModal
);